const riot = require('riot');

riot.tag2('page-error', '<div class="s-full" data-is="module-error" status-code="{statusCode}" error-message="{errorMessage}"></div>', 'page-error,[data-is="page-error"]{display:block}', '', function(opts) {
    this.preload = ({req, res}) => {
      let { statusCode, errorMessage, title } = app.utils.getErrorItem({ status_code: res.statusCode, error: res.error });

      return {
        statusCode,
        errorMessage,
        title,
      };
    };

    this.head = () => {
      return {
        title: this.title,
      };
    };
});